import { useEffect, useState } from "react";
import setThemeColor from "../../utils/setThemeColor/setThemeColor";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import MyRecipesPage from "../MyRecipesPage/MyRecipesPage";
import ExplorePage from "../ExplorePage/ExplorePage";
import { setIsWaiting } from "../../redux/actions/appActions";
import setWebPageTitle from "../../utils/setWebPageTitle/setWebPageTitle";
import setWebPagePreviewImage from "../../utils/setWebPagePreviewImage/setWebPagePreviewImage";

const HomePage: React.FC = () => {
    const isLoggedIn = useSelector((state: RootState) => state.client.isLoggedIn);
    const [isMounted, setIsMounted] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setThemeColor("#ffffff");
        setWebPageTitle();
        setWebPagePreviewImage();
        setIsMounted(true);
        dispatch(setIsWaiting(true));
    }, []);

    return <div>{isMounted ? isLoggedIn ? <MyRecipesPage /> : <ExplorePage /> : <div></div>}</div>;
};

export default HomePage;
